import { useMutation, useQueryClient } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { foldersCacheKey } from './useFolders';
import { templatesCacheKey } from './useTemplates';

const useCopyDataBetweenTenants = () => {
  const client = useQueryClient();

  const {
    mutate: copyLessonBetweenTenants,
    isPending: isSavingLesson,
    isSuccess: copyLessonSuccess,
  } = useMutation({
    mutationFn: ({
      lessonId,
      fromTenantId,
      toTenantId,
    }: {
      lessonId: string;
      fromTenantId: string;
      toTenantId: string;
      onSuccessFunction: () => void;
    }) => {
      return BackendService.instance.tenant.copyLessonToTenant({
        lessonId,
        fromTenantId,
        toTenantId,
      });
    },

    onSettled: () => {
      client.invalidateQueries({
        queryKey: [templatesCacheKey]
      });
    },

    onSuccess: (data, { onSuccessFunction }) => {
      if (onSuccessFunction) {
        onSuccessFunction();
      }
    }
  });
  const {
    mutate: copyFolderBetweenTenants,
    isPending: isSavingFolder,
    isSuccess: copyFolderSuccess,
  } = useMutation({
    mutationFn: ({
      folderId,
      fromTenantId,
      toTenantId,
    }: {
      folderId: string;
      fromTenantId: string;
      toTenantId: string;
      onSuccessFunction: () => void;
    }) => {
      return BackendService.instance.tenant.copyFolderToTenant({
        folderId,
        fromTenantId,
        toTenantId,
      });
    },

    onSettled: () => {
      client.invalidateQueries({ queryKey: foldersCacheKey });
      client.invalidateQueries({
        queryKey: [templatesCacheKey]
      });
    },

    onSuccess: (data, { onSuccessFunction }) => {
      if (onSuccessFunction) {
        onSuccessFunction();
      }
    }
  });

  return {
    copyLessonBetweenTenants,
    copyFolderBetweenTenants,
    isCopyingBetweenTenants: isSavingFolder || isSavingLesson,
    copySuccess: copyLessonSuccess || copyFolderSuccess,
  };
};

export default useCopyDataBetweenTenants;
